import React from 'react';
import {ComponentFrame} from "../../frame/ComponentFrame";
import {SectionHeader} from "../section-header/SectionHeader";

export class Distributors extends React.Component {

  constructor(props) {
    super(props);

    this.image = {
      backgroundImage: 'url(' + require('../../assets/images/placeholder.png') + ')'
    }
  }

  render(){
    return (
      <div className="distributor-image-container ">
        <ComponentFrame tag="section"
                        header={
                          <SectionHeader align="center"
                                         color="transparent"
                                         title="DISTRIBUTORS"
                                         subtitle="Obelux has an extensive partner network globally. Please contact Obelux Oy directly to find your local representative."
                          />
                        }>
        </ComponentFrame>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/distributors/Distributors.js